import { addDoc, collection } from "firebase/firestore";
import { votesTable } from "../../helpers/tables";
import { count, queryMany, queryOne } from "./all";
import { getMixpanelQuestType, trackEvent } from "../../helpers/mixpanel";
import { getAuth } from "firebase/auth";
import { db } from "../../helpers/firebase";

const table = votesTable;

const voteModel = {
  create: async (props) => {
    const { quest, voteIds, storyworld } = props;
    const user = getAuth().currentUser;

    await addDoc(collection(db, votesTable), {
      voteIds,
      pollId: quest.poll.id,
      questId: quest.id,
      creator: user.uid,
      createdAt: new Date(),
      lastUpdated: new Date(),
    });
    trackEvent("User Voted", {
      quest_id: quest.id,
      quest_name: quest.title,
      quest_type: getMixpanelQuestType(quest),
      poll_id: quest.poll.id,
      storyworld_id: quest.storyworld,
      storyworld_name: storyworld.title,
      title: `${storyworld.title}: ${quest.title}`,
      vote_amount: voteIds.length,
    });
    return "Successfully wrote user vote data";
  },
  getOneById: async (id) => {
    const data = await queryOne({ table, id });
    return data;
  },
  getMany: async (...args) => {
    const data = await queryMany({
      table,
      conditions: [...args],
    });

    return data;
  },
  getManyByUserId: async (userId, ...args) => {
    const data = await queryMany({
      table,
      conditions: [["creator", "==", userId], ...args],
    });

    return data;
  },
  count: async (...args) => {
    const data = await count({
      table,
      conditions: [...args],
    });

    return data;
  },
};

export default voteModel;
